import { render } from "./dragSort.vue?vue&type=template&id=4cbeca69&scoped=true"
import script from "./dragSort.vue?vue&type=script&lang=js"
export * from "./dragSort.vue?vue&type=script&lang=js"

import "./dragSort.vue?vue&type=style&index=0&id=4cbeca69&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbeca69"]])

export default __exports__